import React from 'react';

const ThankYou = () => {
  return (
    <div className="min-h-screen w-full flex justify-center items-center bg-gradient-to-br  px-4 py-12">
      <div className="bg-white rounded-[30px] shadow-xl max-w-[480px] w-full p-10 text-center flex flex-col gap-6 font-sora">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#422019]">
          Thank you for your feedback!
        </h2>

        <p className="text-gray-700 text-sm sm:text-base leading-relaxed font-medium">
          Every thought you shared helps us grow—and makes the experience better for others too.
        </p>

        <p className="text-gray-700 text-sm sm:text-base leading-relaxed font-medium">
          We’re lucky to have thoughtful explorers like you on this journey. Kumar is taking notes ✍️ and already working on making things even better for tomorrow.
        </p>

        <p className="italic text-[#5a4033] font-semibold text-sm sm:text-base mt-2">
          “Great journeys are built one reflection at a time.”
        </p>
      </div>
    </div>
  );
};

export default ThankYou;
